import axios from "axios";

export const postPlanet = async data => {
  const response = await axios.post("/orders/get-scenes/", data);
  return response.data;
};
